module.exports = __webpack_public_path__ + "static/media/IMG_4209.d57a82b7.JPG";